import type { OnsiteEditDto } from "@intelligems/ig-types";
import { createSelector } from "@reduxjs/toolkit";
import { componentSlice } from "@src/store/slices/experienceBuilder/component/slice";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

export const getInsertPlaceholder = createSelector(
  componentSlice.selectors.getPhase,
  componentSlice.selectors.getInsertContext,
  experienceBuilderSlice.selectors.getVariationId,
  (phase, insertContext, variationId): OnsiteEditDto | undefined => {
    if (phase !== "selecting" || !insertContext) return undefined;

    return {
      id: "insert-placeholder",
      variationId,
      querySelectors: [insertContext.selector],
      insertType:
        insertContext.position === "before" ? "beforebegin" : "afterend",
      onsiteEditType: "html",
      replace: `<${insertContext.display === "inline" ? "span" : "div"} class="ig-insert-placeholder">Component</${insertContext.display === "inline" ? "span" : "div"}>`,
      find: "",
      remove: false,
      skip: false,
      isRegex: false,
      isHtml: true,
      isImage: false,
    };
  }
);
